import { render, staticRenderFns } from "./DocumentsAdminContractors.vue?vue&type=template&id=7df0af60"
import script from "./DocumentsAdminContractors.vue?vue&type=script&lang=ts"
export * from "./DocumentsAdminContractors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7df0af60')) {
      api.createRecord('7df0af60', component.options)
    } else {
      api.reload('7df0af60', component.options)
    }
    module.hot.accept("./DocumentsAdminContractors.vue?vue&type=template&id=7df0af60", function () {
      api.rerender('7df0af60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/documents/admin/DocumentsAdminContractors.vue"
export default component.exports